function BankTooltip() {
    return (
        <>
            <h1>Bank Info</h1>
            <p>
                Use this page to view bank information and add new requirements such as requesting banking information
                or EFT document signing.
            </p>
        </>
    );
}

export default BankTooltip;
